import { render } from "./ActionView.vue?vue&type=template&id=284da171&scoped=true"
import script from "./ActionView.vue?vue&type=script&lang=js"
export * from "./ActionView.vue?vue&type=script&lang=js"

import "./ActionView.vue?vue&type=style&index=0&id=284da171&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284da171"]])

export default __exports__